define('cart_promocode_notifications.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('cart_promocode_notifications', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return " \n";
},"useData":true}, 'extensions/Tavano/Custom_TT_Master_Theme_Lapwing/1.7.8/', 'extensions/Tavano/Custom_TT_Master_Theme_Lapwing/1.7.8/', Handlebars);
});